module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectClients":"Select Clients"},"fr":{"selectClients":"Choisir les clients"}}')
  delete Component.options._Ctor
}
